import { getEffectivePageRotation } from "../../utils/documentOrientation";

export const buildPreviewPageViewport = (page, displayRotation, scale = 1) => {
  if (!page?.getViewport) return null;

  const rotation = getEffectivePageRotation(page?.rotate, displayRotation);
  const viewport = page.getViewport({ scale, rotation });

  if (!viewport || !Array.isArray(viewport.transform)) return null;

  return {
    width: viewport.width,
    height: viewport.height,
    rotation: viewport.rotation,
    transform: [...viewport.transform],
  };
};
